var moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e(2443), __webpack_require__.e(7043), __webpack_require__.e(4570), __webpack_require__.e(6490), __webpack_require__.e(723), __webpack_require__.e(4914), __webpack_require__.e(8806), __webpack_require__.e(4942), __webpack_require__.e(3654)]).then(() => (() => ((__webpack_require__(94830)))));
	},
	"./copyWorkflowViews": () => {
		return Promise.all([__webpack_require__.e(7043), __webpack_require__.e(6490), __webpack_require__.e(4914), __webpack_require__.e(8806), __webpack_require__.e(9951)]).then(() => (() => ((__webpack_require__(19951)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});